/**
 * Site Feedback API Service
 * Handles communication with /api/site-feedback (site-level NPS + PMF).
 *
 * Backend reference: server/app/routes/siteFeedbackRoute.js
 * Created 2026-05-03 (Sunday polish — site feedback form).
 *
 * NB: This is for SITE-level feedback (the LocalGenie product itself).
 * Neighborhood reviews live in services/reviewsApi.js.
 * Per-recommendation thumbs live in services/feedbackApi.js.
 */

import axios from 'axios';

// Same env-var pattern as aiApi.js so production points at Render and
// local dev falls back to localhost.
const SITE_FEEDBACK_API_BASE =
  (process.env.REACT_APP_API_BASE || 'http://localhost:5050') + '/api/site-feedback';

/**
 * Submit site-level feedback.
 *
 * @param {object} payload
 *   @param {number} payload.npsScore     — 0-10, required
 *   @param {string} [payload.pmfResponse] — one of 'very_disappointed' |
 *     'somewhat_disappointed' | 'not_disappointed' | 'havent_tried'
 *   @param {string} [payload.comment]    — free-text, ≤ 1000 chars
 *   @param {string} [payload.email]      — optional email for follow-up
 *   @param {string} [payload.sessionId]  — browser session id, if any
 *
 * @returns {Promise<{success: boolean, data?: any, error?: string}>}
 */
export const submitSiteFeedback = async (payload) => {
  try {
    const res = await axios.post(SITE_FEEDBACK_API_BASE, payload, {
      headers: { 'Content-Type': 'application/json' }
    });
    return { success: true, data: res.data };
  } catch (err) {
    const apiError = err?.response?.data;
    const errorMessage =
      apiError?.details ||
      apiError?.error ||
      err?.message ||
      'Failed to submit feedback.';
    return {
      success: false,
      error: errorMessage,
      status: err?.response?.status
    };
  }
};
